import {Flex} from "@chakra-ui/react";
import Menu from "./components/layout/Menu";
import Footer from "./components/layout/footer/Footer";
import {Route, Routes, useLocation} from "react-router-dom";
import EventDetailPage from "./pages/EventDetailPage/EventDetailPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import ProtectedRoute from "./components/layout/ProtectedRoute";
import {useAuth} from "./providers/AuthProvider";
import EventsTable from "./pages/EventsTable/EventsTable";
import AddEventForm from "./pages/AddEventForm/AddEventForm";
import EditEventForm from "./pages/EditEventForm/EditEventForm";

function App() {
    const {user} = useAuth();
    const location = useLocation();

    const isLoginPage = location.pathname === "/login";
    const isPreviewPage = /^\/events\/[^/]+\/preview$/.test(location.pathname);

    return (
            <Flex minH={'100vh'}
                  flexDirection={'column'}
                  alignItems={'center'}>
                {!isLoginPage && !isPreviewPage && <Menu />}
                {isPreviewPage && <Menu variant="preview" />}
                <Flex bg={'#F1F1F1'} w={'100%'} justifyContent={'center'} h={'100%'}>
                    <Flex w={'100%'} alignItems={"center"} justifyContent="center">
                        <Routes>
                            <Route path={"/"} element={<ProtectedRoute user={user}><EventsTable /></ProtectedRoute>}/>
                            <Route path={"/events/new"} element={<ProtectedRoute user={user}><AddEventForm /></ProtectedRoute>}/>
                            <Route path={"/login"} element={<LoginPage />}/>
                            <Route path={"/events/:id/edit"} element={<EditEventForm />} />
                            <Route path={"/events/:id/preview"} element={<EventDetailPage />} />
                        </Routes>
                    </Flex>
                </Flex>
                {!isLoginPage && <Footer />}
            </Flex>
    );
}

export default App;
